
import { FETCH_AGENCES, FETCH_UPDATE_AGENCES } from '../types';

export const agenceReducer = (
  state = { isLoading: true, data: {} },
  action: { type: any; payload: any }
) => {
  switch (action.type) {
    case FETCH_AGENCES:
      return {
        isLoading: false,
        data: action.payload,
      };
    default:
      return state;
  }
};

export const updateAgencesReducer = (
  state = { isLoading: true, data: {} },
  action: { type: any; payload: any }
) => {
  switch (action.type) {
    case FETCH_UPDATE_AGENCES:
      return {
        isLoading: false,
        data: action.payload,
      };
    default:
      return state;
  }
};
